import { render, staticRenderFns } from "./StemdoerOverviewCard.vue?vue&type=template&id=2dbc0c7d&scoped=true"
import script from "./StemdoerOverviewCard.vue?vue&type=script&lang=ts"
export * from "./StemdoerOverviewCard.vue?vue&type=script&lang=ts"
import style0 from "./StemdoerOverviewCard.vue?vue&type=style&index=0&id=2dbc0c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc0c7d",
  null
  
)

export default component.exports